function c(e, n) {
  return Object.keys(n).forEach((t) => {
    n.hasOwnProperty(t) && (n[t] instanceof Object && e[t] instanceof Object ? e[t] = c(e[t], n[t]) : e[t] = n[t]);
  }), e;
}
const l = ["en", "de", "it", "fr", "az"];
let a, o;
function u() {
  return window.navigator.language.split("-")[0].toLowerCase();
}
function r() {
  const e = Object.keys(o);
  return l.filter((n) => e.includes(n));
}
function f() {
  const e = u();
  return r().includes(e) ? e : "en";
}
function g(e) {
  return o = e, { options: {
    locale: f(),
    fallbackLocale: "en",
    messages: o,
    silentTranslationWarn: !1,
    missing: (t, s) => {
      console.warn(`Translation missing: [${t}] ${s}`);
    }
  } };
}
function d(e) {
  a = e;
}
function p(e) {
  var n;
  r().includes(e) || console.error(`Locale '${e}' not supported`), a.locale = e, (n = document.querySelector("html")) == null || n.setAttribute("lang", e);
}
function L(e) {
  Object.entries(e).forEach((n) => {
    const t = n[0], s = n[1], i = c(o[t], s);
    a.setLocaleMessage(t, i);
  });
}
export {
  a as i18n,
  L as overrideTranslations,
  d as updateInstance,
  p as updateLocale,
  g as useLocalization
};
